import { QuestaoArquivo } from "../../item-questionario/questao-arquivo/model/questao-arquivo.model";
import { QuestaoData } from "../../item-questionario/questao-data/model/questao-data.model";
import { QuestaoDescritiva } from "../../item-questionario/questao-descritiva/model/questao-descritiva";
import { QuestaoDropdown } from "../../item-questionario/questao-dropdown/model/questao-dropdown";
import { QuestaoMultiplaescolha } from "../../item-questionario/questao-multiplaescolha/model/questao-multiplaescolha.model";
import { QuestaoObjetiva } from "../../item-questionario/questao-objetiva/model/questao-objetiva.model";
import { ItemQuestionarioSecao } from "../../item-questionario/secao/model/item-questionario-secao.model";
import { ItemQuestionario } from "../item-questionario-base";
import { QuestaoDTO } from "../model/dto/questao-com-status-respondida.model";
import { Questao } from "../model/questao.model";
import { TipoItemQuestionario } from "../model/tipo-item-questionario.enum";

interface IItemQuestionarioBundle {
  materialIcon: string;
  label: string;
  questaoEstruturada: boolean;
}

export class ItemQuestionarioFactory {

  hashInfo: Map<TipoItemQuestionario, IItemQuestionarioBundle>;

  constructor() {
    this.hashInfo = new Map<TipoItemQuestionario, IItemQuestionarioBundle>();
  }

  getInfoBundle(tipo: TipoItemQuestionario): IItemQuestionarioBundle {
    if ( !tipo ) {
      return null;
    }

    const bundle = this.hashInfo.get(tipo);
    if ( bundle ) {
      return bundle;
    }

    const item = ItemQuestionarioFactory.getInstance(tipo);

    const novoBundle: IItemQuestionarioBundle = {
      materialIcon: '',
      label: '',
      questaoEstruturada: false
    };

    if ( item.getMaterialIcon ) {
      novoBundle.materialIcon = item.getMaterialIcon();
    }
    if ( item.getLabel ) {
      novoBundle.label = item.getLabel();
    }
    if ( item.isQuestaoEstruturada ) {
      novoBundle.questaoEstruturada = item.isQuestaoEstruturada();
    }

    this.hashInfo.set(tipo, novoBundle);

    return novoBundle;
  }

  static getInstanceFromQuestao(questao: Questao): ItemQuestionario<any> {
    const questaoDTO: QuestaoDTO = QuestaoDTO.getInstanceFromQuestao(questao);
    return ItemQuestionarioFactory.getInstanceFromQuestaoDTO(questaoDTO);
  }

  static getInstanceFromQuestaoDTO(questao: QuestaoDTO): ItemQuestionario<any> {
    const itemQuestionario = ItemQuestionarioFactory.getInstance(questao.tipo);
    itemQuestionario.questao = questao;

    return itemQuestionario;
  }

  static getInstance(tipo: TipoItemQuestionario): ItemQuestionario<any> {
    switch (tipo) {
      case TipoItemQuestionario.DATA:
        return new QuestaoData();

      case TipoItemQuestionario.MULTIPLA_ESCOLHA:
        return new QuestaoMultiplaescolha();

      case TipoItemQuestionario.OBJETIVA:
        return new QuestaoObjetiva();

      case TipoItemQuestionario.SECAO:
        return new ItemQuestionarioSecao();

      case TipoItemQuestionario.DROPDOWN:
        return new QuestaoDropdown();

      case TipoItemQuestionario.DESCRITIVA:
      case TipoItemQuestionario.NUMERO:
        return new QuestaoDescritiva();

      case TipoItemQuestionario.ARQUIVO:
        return new QuestaoArquivo();  

      default:
        return null;
    }
  }

}
